import * as React from "react";

import {
  DatePicker,
  MonthInput,
  RadioGroup,
  Select,
  TableSelect,
  TextInput,
} from "../../../Base/Fields";

// store, state
import { constants } from "../../../../../store/otherContracts";
import {
  buildQueryString,
  useFormInstanceField,
} from "../../../../../store/base";

import {
  constants as leaseConstants,
  useLeaseContractPagination,
  performFilter,
  constructStrRep,
} from "../../../../../store/leaseContracts";
import leaseListDefs from "src/components/Tables/LeaseContracts/listDefs";
import GenericField from "../../../Base/FieldComponents/GenericField";
import useActiveFilters from "../../../../../hooks/useActiveFilters";

import {
  useRealEstatePagination,
  constants as realEstateConstants,
  performFilter as realEstatePerformFilter,
  constructStrRep as realEstateConstructStrRep,
} from "../../../../../store/realEstates";
import realEstateListDefs from "../../../../Tables/RealEstate/listDefs";
import { useFilteredBuildings } from "../../../../../store/buildings";
import { FormAreaTitle } from "../../../Base/Chapters/styles";
import TableSelectField from "src/components/Forms/Base/Fields/TableSelectField";
import RealEstateTable from "src/components/Tables/RealEstate/FullTable";
import LeaseContractsTable from "src/components/Tables/LeaseContracts/FullTableNewVersion";

export default ({ method, contractType }) => {
  const { filteredRealEstates } = useActiveFilters();

  const storeName = constants.STORE_NAME;
  const endDate = useFormInstanceField({
    storeName,
    fieldKey: "end_date",
  });

  const renewIndefinetely = useFormInstanceField({
    storeName,
    fieldKey: "renew_indefinetely",
  });

  const mainContract = useFormInstanceField({
    storeName,
    fieldKey: "main_contract",
  });

  const persistantQueryString = buildQueryString({
    realestate__in: filteredRealEstates,
    draft: false,
  });
  const persistantFilterMethod = (obj) => {
    if (!filteredRealEstates) return obj.draft === false;
    return (
      filteredRealEstates.includes(obj.realestate?.id) && obj.draft === false
    );
  };
  const [buildings] = useFilteredBuildings("");

  return (
    <>
      <FormAreaTitle>Avtalsdetaljer</FormAreaTitle>

      <TextInput
        title="Avtals-ID"
        description="Ange det interna ID:t för avtalet"
        storeName={storeName}
        fieldKey="id_number"
        method={method}
      ></TextInput>

      <div className="grid grid-cols-2 gap-6 mb-6">
        <TableSelectField
          storeName={storeName}
          placeholder="Välj fastighet..."
          title="Fastighet som avtalet ligger under"
          description="Ange vilken fastighet som avtalet ligger under. Om ett huvudavtal väljs så krävs ej detta fält"
          method={method}
          fieldKey="realestate"
          TableComponent={RealEstateTable}
        />
      </div>

      {contractType === "existing" && (
        <Select
          title="Status på avtalet"
          storeName={storeName}
          method={method}
          fieldKey="status"
          forceChoices={[
            { v: 0, d: "Aktiv" },
            { v: 6, d: "Uppsagt" },
          ]}
        />
      )}

      <Select
        title="Kategori"
        storeName={storeName}
        method={method}
        fieldKey="category"
      />

      <div className="grid grid-cols-2 gap-6 mb-6">
        <TableSelectField
          storeName={storeName}
          method={method}
          title="Koppla till huvudavtal"
          placeholder="Välj huvudavtal..."
          fieldKey="main_contract"
          TableComponent={LeaseContractsTable}
        />
      </div>

      {!mainContract && (
        <GenericField
          storeName={storeName}
          method={method}
          ctFieldKey="content_type"
          idFieldKey="object_id"
          realEstateIds={filteredRealEstates}
        />
      )}

      <DatePicker
        title="Startdatum"
        description="Datum när avtalet träder i kraft"
        storeName={storeName}
        fieldKey="start_date"
        method={method}
      />

      <DatePicker
        storeName={storeName}
        fieldKey="end_date"
        title="Slutdatum"
        description="Lämna tomt om avtalet är tillsvidare"
        method={method}
      />

      <MonthInput
        title="Uppsägningstid"
        storeName={storeName}
        fieldKey="notify_interval"
        method={method}
      />

      {endDate && (
        <RadioGroup
          storeName={storeName}
          fieldKey="renew_indefinetely"
          title="Förlängning vid passerat slutdatum"
          description="Välj hur ett passerat slutdatum utan att avtalet har sagts upp ska hanteras."
          method={method}
          forceHorizontalToolTipPlacement="left"
          forceVerticalToolTipPlacement="top"
          defaultValue={false}
          options={[
            {
              label:
                "Förläng med vald förlängningstid när slutdatumet passeras",
              value: false,
            },
            {
              label: "Förläng på obestämd tid när slutdatumet passeras",
              value: true,
            },
            {
              label:
                "Förläng ej när slutdatumet passeras (kräver uppsägningstid)",
              value: "no_renewal",
            },
          ]}
        />
      )}

      {!!endDate && !renewIndefinetely && (
        <MonthInput
          storeName={storeName}
          title="Förlängningstid"
          description="Ange i hur långa intervall avtalet förlängs"
          fieldKey="renew_interval"
          method={method}
        />
      )}

      <MonthInput
        title="Varna så här lång tid innan avtalet går ut "
        description="Pigello skickar en notis om att avtalet är på väg att gå ut så här lång tid innan slutdatum + uppsägningstid"
        storeName={storeName}
        fieldKey="warning_interval"
        method={method}
      />
    </>
  );
};
